import * as React from 'react';
import { Page } from '../../components/atoms/layout/Page';
import { PageHeader } from '../../components/atoms/layout/PageHeader';
import { PageBody } from '../../components/atoms/layout/PageBody';
import './homePage.module.scss';
import { observer, Provider } from 'mobx-react';
import { observable } from 'mobx';
import { HomePageState } from './states/HomePageState';
import { Route, Switch } from 'react-router';
import { TopPane } from '../../components/organisms/home/TopPane';
import { HomePageHeader } from '../../components/organisms/home/HomePageHeader';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { authenticated } from '../../components/hocs/authenticated';
import { UserTutorialHeader } from '../../components/organisms/user_tutorial/UserTutorialHeader';
import { UserTutorialCompletionContext } from '../../contexts/userTutorialCompletion';
import { UserTutorialDetailPaneState } from '../../components/organisms/user_tutorial_completions/states/UserTutorialDetailPaneState';

type Props = {
    match: {
        url: string;
    };
};

@withNavigation(NavigationSpecs.home('white'))
@authenticated
@observer
export class HomePage extends React.Component<Props> {
    @observable pageState = new HomePageState();
    @observable resource = new UserTutorialDetailPaneState();
    componentDidMount(): void {
        this.pageState.init();
        this.resource.init();
    }

    render() {
        const userTutorialContext = {
            resource: this.resource,
        };
        const { url } = this.props.match;
        return (
            <Page id="home-page" styleName="home-page">
                <PageHeader title="HOME" subTitle="ホーム" />
                <PageBody styleName="body">
                    <Provider homeState={this.pageState}>
                        <>
                            <UserTutorialCompletionContext.Provider value={userTutorialContext}>
                                <UserTutorialHeader />
                            </UserTutorialCompletionContext.Provider>
                            <HomePageHeader />
                            <div styleName="main-pane">
                                <Switch>
                                    <UserTutorialCompletionContext.Provider value={userTutorialContext}>
                                        <Route path={`${url}/`} component={TopPane} />
                                    </UserTutorialCompletionContext.Provider>
                                </Switch>
                            </div>
                        </>
                    </Provider>
                </PageBody>
            </Page>
        );
    }
}
